import { render, staticRenderFns } from "./privacySetting.vue?vue&type=template&id=aa82d5ec&scoped=true"
import script from "./privacySetting.vue?vue&type=script&lang=js"
export * from "./privacySetting.vue?vue&type=script&lang=js"
import style0 from "./privacySetting.vue?vue&type=style&index=0&id=aa82d5ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa82d5ec",
  null
  
)

export default component.exports